import { useMemo, useRef } from 'react';

import { RunSchema } from '@/types/schema';

export const useIsRunFinished = ({
  runs,
  expectedFeedbackKeys,
}: {
  runs: RunSchema[];
  expectedFeedbackKeys?: string[];
}) => {
  const isRunFinishedRef = useRef(false);
  const isRunFinished = useMemo(() => {
    if (isRunFinishedRef.current) return true;
    const runToUse = runs[0];
    if (!runToUse) return false;
    // if we don't have evaluators we don't care about feedback stats
    const hasEvaluators = (expectedFeedbackKeys?.length ?? 0) > 0;
    if (!hasEvaluators) {
      isRunFinishedRef.current = true;
      return true;
    }
    // an indirect way to determine stopping condition for polling session
    // we check that all feedback stats have the same n value as the run count (accounts for repetitions)
    const hasFeedbackStats =
      runToUse.feedback_stats &&
      Object.keys(runToUse?.feedback_stats).length > 0;

    if (!hasFeedbackStats) {
      isRunFinishedRef.current = false;
      return false;
    }

    const allMatch =
      Object.values(runToUse.feedback_stats!).every(
        (stat) => stat.n === runs.length
      ) &&
      Object.keys(runToUse.feedback_stats!).length ===
        expectedFeedbackKeys?.length;
    isRunFinishedRef.current = allMatch;
    return allMatch;
  }, [runs, expectedFeedbackKeys]);
  return isRunFinished;
};
